import { gql } from '@apollo/client';

export default gql`
  mutation updateRecyleRuleSetMutation($input: RecycleRuleSetInput!) {
    updateRecyleRuleSet(input: $input) {
      id
      recycle {
        codes
        acquirerId
        delay {
          type
          value
        }
        rules {
          attribute
          operator
          value
        }
        type
      }
    }
  }
`;
